<template lang="pug">
div(class="tl-loading-text-dots")
    div(
        :style="{ width: (size + 6) * 3 + 3 + 'px' }"
        class="spinner"
    )
        div(
            :style="dotStyle"
            class="bounce1"
        )
        div(
            :style="dotStyle"
            class="bounce2"
        )
        div(
            :style="dotStyle"
            class="bounce3"
        )
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    size: {
        type: [String, Number],
        default: 7,
    },
})

const size = computed(() => parseInt(props.size, 10))

const dotStyle = computed(() => ({
    width: `${size.value}px`,
    height: `${size.value}px`,
    backgroundColor: `var(--tl-color-base-black)`,
}))
</script>

<style lang="sass" scoped>
.tl-loading-text-dots
    .spinner
        text-align: center
        overflow: hidden

    .spinner > div
        float: left
        margin: 3px
        background-color: #333

        border-radius: 100%
        animation: sk-bouncedelay 1.4s infinite ease-in-out both

    .spinner .bounce1
        animation-delay: -0.32s

    .spinner .bounce2
        animation-delay: -0.16s

    @keyframes sk-bouncedelay
        0%, 80%, 100%
            transform: scale(0)
        40%
            transform: scale(1.0)
</style>
